module.exports = __webpack_public_path__ + "img/chess_japanchess15.31099733.png";